module.exports = __webpack_public_path__ + "img/venuetwo-jkxwdk.456cf3f1.png";